import { render } from "./MTKBookGroupCard.vue?vue&type=template&id=d787b058&scoped=true"
import script from "./MTKBookGroupCard.vue?vue&type=script&lang=js"
export * from "./MTKBookGroupCard.vue?vue&type=script&lang=js"

import "./MTKBookGroupCard.vue?vue&type=style&index=0&id=d787b058&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d787b058"

export default script